import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Photo from '@alltrails/shared/icons/Photo';
import { COLOR_BRAND_PRIMARY } from '@alltrails/shared/denali/tokens';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import ActionBarItem from '../../ActionBarItem';
import Lightbox from '../../shared/Lightbox';
import { inIframe } from '../../../utils/trail_helpers';
import { urlReformatPhotos } from '../../../utils/lightbox_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class PhotosMenuItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lightboxOpen: false,
      startingPhotosIndex: 0
    };
  }

  handleClick = e => {
    e.preventDefault();

    if (this.props.adminUser && this.props.trailId) {
      return this.openAdminLink();
    }

    if (this.props.slug && !inIframe()) {
      const path = LanguageSupportUtil.wrapUrlSafe(`/${this.props.slug}/photos`, this.props.languageRegionCode);
      window.location.href = path;
      return;
    }

    this.openLightbox(0);
  };

  handleCloseRequest() {
    this.setState({ lightboxOpen: false, startingPhotosIndex: null });
  }

  openAdminLink() {
    const contributePath = `/contribute/admin/photos?trail_id=${this.props.trailId}`;
    window.open(contributePath, '_blank');
  }

  openLightbox(startingPhotosIndex) {
    if (inIframe()) {
      const data = this.getLightboxProps(this.state.startingPhotosIndex);
      const event = new CustomEvent('toggleModal', { detail: data });
      window.parent.document.dispatchEvent(event);
    } else {
      this.setState({ lightboxOpen: true, startingPhotosIndex });
    }
  }

  getLightboxProps(startingPhotosIndex) {
    return {
      images: urlReformatPhotos(this.props.photos),
      handleCloseRequest: this.handleCloseRequest,
      isOpen: true,
      startingIndex: startingPhotosIndex,
      trailId: this.props.trailId
    };
  }

  renderLightbox() {
    if (!this.state.lightboxOpen) {
      return;
    }

    return <Lightbox {...this.getLightboxProps(this.state.startingPhotoIndex)} />;
  }

  render() {
    return (
      <>
        <ActionBarItem
          href={LanguageSupportUtil.wrapUrlSafe(`/${this.props.slug}/photos`, this.props.languageRegionCode)}
          onClick={this.handleClick}
          icon={<Photo color={COLOR_BRAND_PRIMARY} />}
          title={StringConstantsMixin.strings.TAB_NAMES.PHOTOS}
          count={this.props.count}
          languageRegionCode={this.props.languageRegionCode}
          testId="photos-action"
        />
        {this.renderLightbox()}
      </>
    );
  }
}

PhotosMenuItem.defaultProps = {
  adminUser: false,
  trailId: 0,
  slug: '',
  count: 0
};

PhotosMenuItem.propTypes = {
  adminUser: PropTypes.bool,
  trailId: PropTypes.number,
  slug: PropTypes.string,
  count: PropTypes.number,
  languageRegionCode: PropTypes.string
};

export default PhotosMenuItem;
